import { createContext } from 'react';

interface Props {
  isMainNavigationCollapsed: boolean;
  setIsMainNavigationCollapsed: React.Dispatch<React.SetStateAction<boolean>>;
}

const UiStateContext = createContext<Props>({
  isMainNavigationCollapsed: true,
  setIsMainNavigationCollapsed: () => {},
});

export default UiStateContext;
